import React from 'react'
import Grid from '@material-ui/core/Grid'
import ViewMode from './ViewMode'
import EditMode from './EditMode'
import Content from 'components/shared/Content'
import Typography from '@material-ui/core/Typography'
interface Props {
  canSave: boolean,
  device: any,
  editMode: boolean,
  editModeSensor: boolean,
  onEditSensor: () => void,
  onSave: () => void,
  onCancel: () => void,
  onInputChange: (
    prop: string
  ) => (
      evt:
        | React.ChangeEvent<HTMLInputElement>
        | React.ChangeEvent<HTMLSelectElement>
    ) => void
  onDateChange: (
    prop: string
  ) => (
      evt: React.ChangeEvent<HTMLInputElement>
    ) => void
  mbSelectDate: string,
  altSelectDate: string
}

const SensorInfo = ({
  canSave,
  device,
  editMode,
  editModeSensor,
  onEditSensor,
  onInputChange,
  onDateChange,
  onSave,
  onCancel,
  mbSelectDate,
  altSelectDate
}: Props) => {
  console.log(device);
  const sensorData = device.info.data

  if (!sensorData) {
    return null
  }

  return (
    <Grid container direction="column">
      {(!editModeSensor && !editMode) && (
        <Grid container item justify="flex-end">
          <img className="clickable" src="/images/icons/edit.svg" onClick={onEditSensor} />
        </Grid>
      )}
      {!editModeSensor && <ViewMode device={device} />}
      {editModeSensor && (
        <EditMode
          canSave={canSave}
          device={device}
          onSave={onSave}
          onCancel={onCancel}
          onInputChange={onInputChange}
          onDateChange={onDateChange}
          mbSelectDate={mbSelectDate}
          altSelectDate={altSelectDate}
        />
      )}
    </Grid>
  )
}

export default SensorInfo
